import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'browseAgentsMenuTitle'
	| 'chatHistoryMenuTitle'
	| 'pulseMenuTitle'
	| 'tasksMenuTitle'
	| 'scheduledChatsMenuTitle'
	| 'searchWorkMenuTitle'
	| 'allChatsMenuTitle'
	| 'recommendedSpacesMenuTitle'
	| 'defaultAgentName'
	| 'changeAgent';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		browseAgentsMenuTitle: {
			id: 'ai-mate.chat-header.browse-agents-title',
			defaultMessage: 'Browse agents',
			description: 'Title of the browse agents menu page in the chat header',
		},
		chatHistoryMenuTitle: {
			id: 'ai-mate.chat-header.chat-history-title',
			defaultMessage: 'Chat History',
			description: 'Title of the chat history menu page in the chat header',
		},
		pulseMenuTitle: {
			id: 'ai-mate.chat-header.insights-title',
			defaultMessage: 'Insights',
			description: 'Title of the Insights menu page that shows the Insights Feed',
		},
		tasksMenuTitle: {
			id: 'ai-mate.chat-header.tasks-title',
			defaultMessage: 'Tasks',
			description: 'Title of the Tasks menu page in the chat header',
		},
		scheduledChatsMenuTitle: {
			id: 'ai-mate.chat-header.scheduled-chats-title',
			defaultMessage: 'Scheduled chats',
			description:
				'Heading displayed at the top of the Scheduled chats menu page in the chat header navigation.',
		},
		searchWorkMenuTitle: {
			id: 'ai-mate.chat-header.search-work-title',
			defaultMessage: 'Search work',
			description: 'Title of the search work menu page in the chat header',
		},
		allChatsMenuTitle: {
			id: 'ai-mate.chat-header.all-chats-menu-title',
			defaultMessage: 'All chats',
			description: 'Title of the refreshed chat history menu page',
		},
		recommendedSpacesMenuTitle: {
			id: 'ai-mate.chat-header.recommended-rovo-spaces-title',
			defaultMessage: 'Recommended Rovo spaces',
			description: 'Title of the recommended spaces menu page in the chat header',
		},
		defaultAgentName: {
			id: 'ai-mate.chat-header.default-agent-name',
			defaultMessage: 'Rovo',
			description: 'Name of the default Rovo chat agent shown in the chat header',
		},
		changeAgent: {
			id: 'ai-mate.chat-header.change-agent',
			defaultMessage: 'Change agent - {agentName}',
			description:
				'Accessible label for the button that opens the agent selector dropdown. The {agentName} placeholder is replaced with the current agent name (e.g. "Rovo") so screen reader users understand the purpose of the button.',
		},
	});

export default message;
